export default "__VITE_ASSET__bd4b6106__"